import React from 'react';
import { makeStyles } from '@material-ui/core';

export interface DamagePhotoMarkerProps {
  pointX: number;
  pointY: number;
  label: string | null;
}

const DOT_SIZE = 12;

// Root sits exactly on the point; the label hangs from the dot, its top-left corner on it
const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    width: 0,
    height: 0,
    pointerEvents: 'none'
  },
  dot: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 1,
    boxSizing: 'border-box',
    width: DOT_SIZE,
    height: DOT_SIZE,
    transform: 'translate(-50%, -50%)',
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    border: '2px solid #fff',
    boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.35), 0 0 4px rgba(0, 0, 0, 0.4)',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: -2,
      left: -2,
      boxSizing: 'border-box',
      width: DOT_SIZE,
      height: DOT_SIZE,
      borderRadius: '50%',
      border: `2px solid ${theme.palette.primary.main}`,
      animation: '$pulse 1.4s infinite ease-out'
    }
  },
  label: {
    position: 'absolute',
    top: 0,
    left: 0,
    whiteSpace: 'nowrap',
    padding: '6px 20px',
    // Square top-left corner so the pill hangs from the dot
    borderRadius: '0 999px 999px 999px',
    backgroundColor: '#fff',
    border: `2px solid ${theme.palette.primary.main}`,
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
    color: '#1F2857',
    fontSize: 13,
    fontWeight: 700,
    lineHeight: '18px'
  },
  '@keyframes pulse': {
    '0%': {
      transform: 'scale(1)',
      opacity: 1
    },
    '100%': {
      transform: 'scale(2.6)',
      opacity: 0
    }
  }
}));

const DamagePhotoMarker: React.FC<DamagePhotoMarkerProps> = ({ pointX, pointY, label }) => {
  const classes = useStyles();

  return (
    <span className={classes.root} style={{ left: `${pointX}%`, top: `${pointY}%` }}>
      <span className={classes.dot} />
      {label && <span className={classes.label}>{label}</span>}
    </span>
  );
};

export default DamagePhotoMarker;
